import { useFormik } from "formik";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import { NAME_SPACES } from "shared/locales/constants";
import { bindInputProps } from "utils/helpers/input";
import ActionButtons from "../Components/ActionButtons";
import DocumentDownload from "../Components/DocumentDownload";
import Footer from "../Components/Footer";
import Head from "../Components/Head";
import InfoBox from "../Components/InfoBox";
import Input from "../Components/Input";
import Layout from "../Components/Layout";
import MemberInfo from "../Components/MemberInfo";
import PricingItem from "../Components/PricingItem";
import validation from "./validation";

const View = ({
  initialValues,
  generalCost,
  attachments,
  project,
  subscription,
  onSubmit,
  download,
  onEdit,
  onBack,
}) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const TRANSLATION = t("B2C_LMF.CONTRACT", { returnObjects: true });
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const { handleSubmit, values, setFieldValue, ...formProps } = useFormik({
    initialValues,
    onSubmit,
    validationSchema: validation(
      t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true })
    ),
  });

  const allCheckboxesChecked =
    get(values, "fields.acceptTerms", false) &&
    get(values, "fields.honorDeclaration", false) &&
    get(values, "fields.digitalConsent", false);

  return (
    <>
      <Layout>
        <Head
          description={TRANSLATION.DESCRIPTION}
          title={TRANSLATION.TITLE}
          onBack={onBack}
        />
        <div className="lmf__contract">
          <div className="lmf__contract--content pb-24">
            <div className="lmf__contract--content--column">
              <PricingItem
                title={get(generalCost, "insurancePlan.name")}
                price={get(generalCost, "cost")}
                currency={get(generalCost, "currency")}
                per={"par mois"}
                breakdown={get(
                  project,
                  `fields.upsells.${get(subscription, "insurancePlan.id")}`
                )}
              />
              <DocumentDownload
                title={
                  "Vous pouvez consultez les documents relatifs à votre devis"
                }
                items={attachments}
                download={(id) => download(id)}
              />
              <InfoBox
                variant="danger"
                text={
                  "Je bénéficie de la possibilité de renoncer à mon adhésion dans un délai de 14 jours calendaires à compter de la signature de mon bulletin d’adhésion"
                }
              />
            </div>
            <div className="divider"></div>
            <div className="lmf__contract--content--column">
              <MemberInfo data={subscription} onEdit={(v) => onEdit(v)} />
            </div>
          </div>
          <div className="lmf__contract--infos">
            <span className="lmf__contract--infos--title">
              {TRANSLATION.OPT_INS_TITLE}
            </span>

            <div className="lmf__contract--infos--body">
              {/* <span>{TRANSLATION.OPT_INS.DOCUMENTS.TITLE}</span> */}
              <div>
                <Input
                  type="checkbox"
                  label={TRANSLATION.OPT_INS.DOCUMENTS.ACCEPT_ALL_TERMS}
                  checked={get(values, "fields.acceptTerms", false)}
                  {...bindInputProps({
                    name: "fields.acceptTerms",
                    values,
                    setFieldValue,
                    ...formProps,
                  })}
                />
                <Input
                  type="checkbox"
                  label={TRANSLATION.OPT_INS.DOCUMENTS.ATTEST_ACCURACY}
                  checked={get(values, "fields.honorDeclaration", false)}
                  {...bindInputProps({
                    name: "fields.honorDeclaration",
                    values,
                    setFieldValue,
                    ...formProps,
                  })}
                />
                <Input
                  type="checkbox"
                  label={TRANSLATION.OPT_INS.DOCUMENTS.EMAIL_LEGAL_OPTIN}
                  checked={get(values, "fields.digitalConsent", false)}
                  {...bindInputProps({
                    name: "fields.digitalConsent",
                    values,
                    setFieldValue,
                    ...formProps,
                  })}
                />
              </div>
            </div>
            <ActionButtons
              disabled={!allCheckboxesChecked}
              onNext={handleSubmit}
              buttonText={TRANSLATION.NEXT}
              {...(isMobile && { onBack })}
              className="w-100"
            />
            {/* <Button
              disabled={!allCheckboxesChecked}
              onClick={handleSubmit}
              type={allCheckboxesChecked ? "primary" : "white"}
              size="medium"
              className="w-full"
            >
              <span>{TRANSLATION.NEXT}</span>
            </Button> */}
          </div>

          <Footer variant="left" type="signature" />
        </div>
      </Layout>
    </>
  );
};

export default View;
